module.exports = __webpack_public_path__ + "img/bank-rate-lead-tool-icon.ab1069b1.png";